import TrackingConsent from './TrackingConsent';
import { ConsentCategory } from './constants';

/**
 * Defers execution of an async initializer until the specified consent category is granted.
 * Uses lazy-loading (dynamic import pattern) so the actual SDK code is not bundled
 * until consent is available.
 *
 * @example
 * // In instrumentation-client.ts:
 * consentGatedInit(ConsentCategory.Functional, () =>
 *   import('@framework/sentry/createSentryConfig').then(({ default: init }) => init(config)),
 * );
 */
function consentGatedInit(category: ConsentCategory, loader: () => Promise<void>): void {
  TrackingConsent.getInstance().onConsent(category, () => {
    loader();
  });
}

export default consentGatedInit;
